export default __webpack_public_path__ + "static/media/welcome-male.d2b738f1.png";